import { useFragment } from 'react-relay';
import { TypeMap, frontPageFragment } from './lib';
import type { FrontPageProps } from './types';

export const FrontPage: React.FC<FrontPageProps> = (props) => {
  const page = useFragment(frontPageFragment, props.page);

  const FirstFrontGroup = TypeMap[page.firstGroup.__typename];
  const SecondFrontGroup = TypeMap[page.secondGroup.__typename];
  const ThirdFrontGroup = TypeMap[page.thirdGroup.__typename];

  return (
    <div className="flex flex-row flex-wrap justify-between max-w-[820px] mx-auto pt-[75px] [&_h2]:text-black max-[700px]:max-w-[285px] max-[700px]:[&>div]:basis-full min-[701px]:max-[1100px]:max-w-[565px] min-[701px]:max-[1100px]:[&>div]:basis-[calc(50%-35px)] min-[1101px]:[&>div]:basis-[calc(33.34%-46.67px)]">
      <FirstFrontGroup frontGroup={page.firstGroup} />
      <SecondFrontGroup frontGroup={page.secondGroup} />
      <ThirdFrontGroup frontGroup={page.thirdGroup} />
    </div>
  );
};
